import type { InstallmentDto, LoanOperationListDto } from "../../libs/cognito-api/schemas";

export type ExcelCell = string | number | boolean | null;
export type ExcelTable = ExcelCell[][];

const DEBT_FLOW_HEADERS = [
  "Parcela",
  "Vencimento da parcela",
  "Saldo Devedor",
  "Amortizacao",
  "Comissao Externa",
  "IR Juros",
  "Comissao Interna",
  "Juros Total",
  "Parcela",
  "Taxa de Cambio",
  "Parcela BRL",
  "Valor realizado BRL",
  "Status",
];

const INSTALLMENT_STATUS_LABELS: Record<string, string> = {
  Quoted: "Cotado",
  Settled: "Liquidado",
  Open: "Em aberto",
  Overdue: "Vencido",
  Canceled: "Cancelado",
};

export function normalizeLoanSequentialId(value: string | number): string {
  const text = String(value).trim().toUpperCase();
  const withoutPrefix = text.replace(/^LOAN[\s-]*/i, "");
  const digits = withoutPrefix.replace(/\D/g, "");
  return digits.replace(/^0+(?=\d)/, "");
}

export function findLoanBySequentialId(
  loans: Array<Pick<LoanOperationListDto, "id" | "sequentialId">>,
  sequentialId: string | number
): Pick<LoanOperationListDto, "id" | "sequentialId"> | undefined {
  const expected = normalizeLoanSequentialId(sequentialId);
  return loans.find((loan) => normalizeLoanSequentialId(loan.sequentialId ?? "") === expected);
}

export function buildDebtFlowTable(installments: InstallmentDto[]): ExcelTable {
  const rows = installments
    .slice()
    .sort((a, b) => (a.installmentNumber ?? 0) - (b.installmentNumber ?? 0))
    .map((installment) => [
      installment.installmentNumber ?? null,
      formatDate(installment.dueAt),
      installment.outstandingBalance ?? null,
      installment.amortizationValue ?? null,
      installment.externalComissionTax ?? null,
      installment.incomeTaxOnInterest ?? null,
      installment.internalComissionTax ?? null,
      installment.totalTax ?? null,
      installment.pmtFx ?? null,
      installment.exchangeRate ?? null,
      installment.pmtBrl ?? null,
      installment.settlementTotalBrl ?? null,
      formatStatus(installment.status),
    ]);

  return [DEBT_FLOW_HEADERS, ...rows];
}

function formatDate(value?: string): string | null {
  if (!value) return null;
  const [date] = value.split("T");
  const [year, month, day] = date.split("-");
  if (!year || !month || !day) return value;
  return `${day}/${month}/${year}`;
}

function formatStatus(value?: string): string | null {
  if (!value) return null;
  return INSTALLMENT_STATUS_LABELS[value] ?? value;
}
